import QuoteHeaderDa from "./da/quotes/header";
import QuoteHeaderDe from "./de/quotes/header";
import QuoteHeaderEn from "./en/quotes/header";
import QuoteHeaderEs from "./es/quotes/header";
import QuoteHeaderFi from "./fi/quotes/header";
import QuoteHeaderFr from "./fr/quotes/header";
import QuoteHeaderHr from "./hr/quotes/header";
import QuoteHeaderIt from "./it/quotes/header";
import QuoteHeaderLt from "./lt/quotes/header";
import QuoteHeaderLv from "./lv/quotes/header";
import QuoteHeaderMe from "./me/quotes/header";
import QuoteHeaderNl from "./nl/quotes/header";
import QuoteHeaderPl from "./pl/quotes/header";
import QuoteHeaderSr from "./sr/quotes/header";
import QuoteHeaderSe from "./se/quotes/header";
import QuoteHeaderTr from "./tr/quotes/header";

export default {
  messages: {
    da:{QuoteHeader:QuoteHeaderDa},
    de:{QuoteHeader:QuoteHeaderDe},
    en:{QuoteHeader:QuoteHeaderEn},
    es:{QuoteHeader:QuoteHeaderEs},
    fi:{QuoteHeader:QuoteHeaderFi},
    fr:{QuoteHeader:QuoteHeaderFr},
    hr:{QuoteHeader:QuoteHeaderHr},
    it:{QuoteHeader:QuoteHeaderIt},
    lt:{QuoteHeader:QuoteHeaderLt},
    lv:{QuoteHeader:QuoteHeaderLv},
    me:{QuoteHeader:QuoteHeaderMe},
    mx:{QuoteHeader:QuoteHeaderEs},
    nl:{QuoteHeader:QuoteHeaderNl},
    pl:{QuoteHeader:QuoteHeaderPl},
    sr:{QuoteHeader:QuoteHeaderSr},
    se:{QuoteHeader:QuoteHeaderSe},
    tr:{QuoteHeader:QuoteHeaderTr},
  },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/QuoteHeader.js